module.exports = __webpack_public_path__ + "img/icon_item2.4e62be02.png";